import { IndemnityAgreementSignatureMethod, IndemnityStatus } from "@inrev/common";
import { FC } from "react";
import { Card } from "../ui/Card";
import { NotificationCard } from "../ui/NotificationCard";

export type IndemnityAgreementNotificationProps = {
	status: IndemnityStatus;
	signatureMethod: IndemnityAgreementSignatureMethod;
};

export const IndemnityAgreementNotification: FC<IndemnityAgreementNotificationProps> = ({
	status,
	signatureMethod,
}) => {
	const isPending = status === "pending";
	const isPhysical = signatureMethod === IndemnityAgreementSignatureMethod.physical;

	return (
		isPending &&
		isPhysical && (
			<Card testId="indemnity-agreement-physical-notification">
				<NotificationCard
					type="action"
					text="Upload copy of completed physical indemnity agreement"
				/>
			</Card>
		)
	);
};
